import React from 'react';
import { RouteComponentProps } from 'react-router';
import { withRouter } from "react-router-dom";
import { NavigationPlug } from './adapters/NavigationAdapter/NavigationPlug';
import { wiring } from './App';
import { appDomain } from './domain/AppDomain';
import { INavigateTo } from './domain/navigation/INavigateTo';
import { PrivateRoutes } from './routes/PrivateRoutes';

export class RoutingWrapperBase extends React.Component<RouteComponentProps> {
    render() {
        const navigateFn = (path: string, state?: any) => this.props.history.push(path, state);
        wiring.portResolver.registerInstance<INavigateTo>("INavigateTo", () => new NavigationPlug(navigateFn));
        const hasPermission = appDomain.IAuthenticationService.isAuthenticated();

        console.log("Render RoutingWrapperBase", hasPermission);

        if (hasPermission) {
            return (<PrivateRoutes />);
        }

        return <></>;
    }
}

export const RoutingWrapper = withRouter(RoutingWrapperBase);
